export default "__VITE_ASSET__5e24c5d1__"